import angular from 'angular';

import { colorMigrations } from '../../constants';

export default function Groups(Authentication, Restangular, Utils, PersonaCollection) {
  'ngInject';

  function extendForSpecificGroupType(group) {
    if (group.type === 'location') {
      if (!group.ipAddresses) {
        group.ipAddresses = [];
      }
    }

    // temporary hack until server implements it
    if (group.type === 'position' && group.color?.toUpperCase() in colorMigrations) {
      group.color = colorMigrations[group.color.toUpperCase()];
    }

    if (group.type === 'position' && Authentication.user.hasAccessToLaborCost) {
      if (!('wages' in group)) {
        group.wages = [];
      }

      group.wages.forEach((wage) => {
        Object.assign(wage, {
          fromDate: wage.dateEffective ? Utils.getRealDate(wage.dateEffective) : new Date(),
          regularRate:
            'regularRate' in wage && wage.regularRate !== null ? Number(wage.regularRate) : null,
          positionId: Utils.getId(group.id),
        });
      });

      group.wages = Utils.sortBy(group.wages, 'fromDate');

      group.currentWage = group.wages
        .filter((wage) => !wage.deleted)
        .reduce(
          (reduced, wage) => wage.fromDate <= Date.now() && (wage.id ? wage.regularRate : reduced),
          undefined
        );
    }

    if (group.archivedAt) {
      group.archivedAt = new Date(group.archivedAt);
    }
  }

  Restangular.extendModel('groups', (group) => {
    group.displayName = `${group.name} (${group.type})`;
    group.searchValue = group.displayName;
    group.normalizedDisplayName = Utils.normalizeString(group.displayName);
    group.members = PersonaCollection.getRelationships(group.id).map((u) => ({ id: u.id }));
    group.activeMembers = group.members.filter(
      (m) =>
        PersonaCollection.personasDict[m.id] && !PersonaCollection.personasDict[m.id].deactivatedAt
    );

    if (!('hiddenOnSchedule' in group)) {
      Object.defineProperty(group, 'hiddenOnSchedule', {
        enumerable: true,
        get() {
          return Boolean(
            Authentication.user &&
              Authentication.user.personasHiddenOnScheduleDict &&
              Authentication.user.personasHiddenOnScheduleDict[group.id]
          );
        },
        set(value) {
          if (Authentication.user) {
            if (!('personasHiddenOnScheduleDict' in Authentication.user)) {
              Authentication.user.personasHiddenOnScheduleDict = {};
            }

            Authentication.user.personasHiddenOnScheduleDict[group.id] = value;
          }
        },
      });
    }

    if (group.name) {
      group.sorting = Utils.normalizeString(group.name);
    }

    if (!('active' in group)) {
      group.active = true;
    }

    extendForSpecificGroupType(group);

    if (!group.hoursCap) {
      group.hoursCap = null;
    }

    if (typeof group.budget === 'string') {
      group.budget = Number(group.budget);
    }

    return group;
  });

  Restangular.addRequestInterceptor((element, operation, what) => {
    if (what === 'groups' && (operation === 'post' || operation === 'put')) {
      if ('hoursCap' in element && !element.hoursCap) {
        element.hoursCap = 0;
      }
    }

    return element;
  });

  // Update PersonaCollection and user memberships based on server response
  Restangular.addResponseInterceptor((data, operation, what) => {
    if (what === 'groups') {
      if (operation === 'post') {
        PersonaCollection.addGroup(data);
      }

      if (operation === 'put') {
        PersonaCollection.editGroup(data);
      }

      if (operation === 'remove') {
        if (angular.isArray(data)) {
          data.forEach((item) => {
            PersonaCollection.deleteGroup(item);
          });
        } else {
          PersonaCollection.deleteGroup(data);
        }
      }
    }

    return data;
  });

  return Restangular.service('groups');
}
